import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EditableGridService, SystemApiService } from '@cv-invision/core';
import { DefaultSettingsModel } from '../model/valuetrust.model';

@Injectable({
	providedIn: 'root'
})
export class ValuTrustService extends EditableGridService {

	/**
	 * Get api value
	 */
	get api():any {
		return this.systemApiService.api;
	}

	/**
	 * Get baseUrl value
	 */
	get baseUrl(): any {
		return `${this.api.orders}/utils/valutrust`;
	}

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**** PropertyTypes ****/

	/**
	 * PUT - Save the configuration.
	 */
	saveValuTrustPropertyTypesConfiguration(config: any): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/mapper/property-types`, config);
	}

	/**
	 * GET - Return the list of the  property types configuration mappings.
	 */
	getValuTrustPropertyTypesConfiguration(): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/property-types?includeValutrustInfo=true`);
	}

	/**** OccuopancyTypes ****/

	/**
	 * PUT - Save the configuration.
	 */
	saveValuTrustOccupancyTypesConfiguration(
		config: Array<{ id: string; scopeId: string; acuityId: string }>
	): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/mapper/occupancy-types`, config);
	}

	/**
	 * GET - Return the list of the occupancy types configuration mappings.
	 */
	getValuTrustOccupancyTypesConfiguration(): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/occupancy-types?includeValutrustInfo=true`
		);
	}

	/*******Loan Types **********/

	/**
	 * PUT - Save the configuration.
	 */
	saveValuTrustLoanTypesConfiguration(
		config: Array<{ id: string; scopeId: string; acuityId: string }>
	): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/mapper/loan-types`, config);
	}

	/**
	 * GET - Return the list of the loan types configuration mappings.
	 */
	getValuTrustLoanTypesConfiguration(): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/loan-types?includeValutrustInfo=true`);
	}

	/*******Loan Reasons **********/

	/**
	 * PUT - Save the configuration.
	 */
	saveValuTrustLoanReasonsConfiguration(
		config: Array<{ id: string; scopeId: string; acuityId: string }>
	): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/mapper/loan-reasons`, config);
	}

	/**
	 * GET - Return the list of the  loan reasons configuration mappings.
	 */
	getValuTrustLoanReasonsConfiguration(): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/loan-reasons?includeValutrustInfo=true`);
	}

	/*******Document types **********/

	/**
	 * PUT - Save the configuration.
	 */
	saveValuTrustDocumentTypesConfiguration(config: Array<any>): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/mapper/document-types`, config);
	}

	/**
	 * GET - Return the list of the  loan reasons configuration mappings.
	 */
	getValuTrustDocumentTypesConfiguration(): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/document-types?includeValutrustInfo=true`);
	}

	/*******DEfault Settings **********/

	/**
	 * PUT - Save the configuration.
	 */
	saveValuTrustDefaultSettings(config: DefaultSettingsModel): Observable<any> {
		return this.httpClient.put(`${this.baseUrl}/default-settings`, config);
	}

	/**
	 * GET - Return the list of the  Default Settings configuration mappings.
	 */
	getValuTrustDefaultSettings(): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/default-settings`);
	}

	/**
	 * GET - Return the list of the Valutrust orders messages.
	 */
	getValuTrustMilestoneMessagesStatus(origin: string): Observable<any> {
		return this.httpClient.get(`${this.baseUrl}/mapper/custom-outgoing-messages-status?origin=${origin}`);
	}
}
